// packages/components/src/doctor-ai/SymptomTimelineChart.tsx
import React from 'react';
import { Card, Badge } from '@dopomogai/ui';
import { CalendarDays } from 'lucide-react';
import type { SymptomTimelineData } from '@dopomogai/types'; // Assuming this type is created

export const SymptomTimelineChart: React.FC<{ data: SymptomTimelineData }> = ({ data }) => {
  return (
    <Card noHoverEffect className="bg-white">
      <div className="p-5">
        <h3 className="text-lg font-bold text-slate-800 mb-4">{data.title}</h3>
        <div className="relative pl-6">
          {/* Vertical line */}
          <div className="absolute left-2 top-1 bottom-1 w-0.5 bg-slate-200" />

          <div className="space-y-6">
            {data.events.map((event, index) => (
              <div key={index} className="relative flex items-start gap-4">
                <div className="absolute -left-10 top-0.5 h-5 w-5 bg-white border-2 border-slate-300 rounded-full flex items-center justify-center">
                  <div className="h-2 w-2 bg-emerald-500 rounded-full" />
                </div>
                <div>
                  <p className="text-sm font-semibold text-slate-700">{event.symptom}</p>
                  <p className="text-xs text-slate-500">{new Date(event.date).toLocaleDateString()}</p>
                </div>
                <Badge
                  text={event.severity}
                  accentColor={
                    event.severity.toLowerCase() === 'mild' ? 'blue'
                    : event.severity.toLowerCase() === 'moderate' ? 'yellow'
                    : 'red'
                  }
                />
              </div>
            ))}
          </div>
        </div>
      </div>
    </Card>
  );
};